var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStripeLogosvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 18,
    viewBox: "0 0 41 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61424_16471)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1153 9.23124C40.1153 6.46989 38.7641 4.29102 36.1814 4.29102C33.5878 4.29102 32.0186 6.46989 32.0186 9.20967C32.0186 12.4564 33.8711 14.096 36.5301 14.096C37.8269 14.096 38.8077 13.8047 39.5487 13.3948V11.2375C38.8077 11.6043 37.9577 11.8308 36.8788 11.8308C35.8218 11.8308 34.8846 11.464 34.7647 10.1912H40.0936C40.0936 10.051 40.1153 9.49012 40.1153 9.23124ZM34.732 8.20652C34.732 6.98765 35.4839 6.48068 36.1705 6.48068C36.8352 6.48068 37.5436 6.98765 37.5436 8.20652H34.732Z",
    fill: "#635BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8122 4.29102C26.7443 4.29102 26.0577 4.7872 25.6763 5.13236L25.5346 4.4636H23.1372V17.0407L25.8616 16.469L25.8725 13.4164C26.2648 13.6969 26.8423 14.096 27.8013 14.096C29.7519 14.096 31.5282 12.5427 31.5282 9.12338C31.5173 5.99529 29.7193 4.29102 27.8122 4.29102ZM27.1584 11.7229C26.5154 11.7229 26.134 11.4964 25.8725 11.216L25.8616 7.21416C26.1449 6.90135 26.5372 6.68562 27.1584 6.68562C28.15 6.68562 28.8366 7.78585 28.8366 9.19888C28.8366 10.6443 28.1609 11.7229 27.1584 11.7229Z",
    fill: "#635BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3887 3.65495L22.1239 3.07248V0.882812L19.3887 1.4545V3.65495Z",
    fill: "#635BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1239 4.47461H19.3887V13.9128H22.1239V4.47461Z",
    fill: "#635BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4574 5.27298L16.283 4.47478H13.9292V13.913H16.6536V7.51657C17.2965 6.68601 18.3863 6.83702 18.7241 6.95568V4.47478C18.3754 4.34534 17.1004 4.10803 16.4574 5.27298Z",
    fill: "#635BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0082 2.13379L8.34928 2.69469L8.33838 11.3347C8.33838 12.9311 9.54799 14.1068 11.1608 14.1068C12.0544 14.1068 12.7083 13.945 13.0679 13.7509V11.5612C12.7191 11.7014 10.9974 12.1976 10.9974 10.6012V6.77199H13.0679V4.47446H10.9974L11.0082 2.13379Z",
    fill: "#635BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.64182 7.21416C3.64182 6.79349 3.99054 6.63169 4.5681 6.63169C5.3963 6.63169 6.44246 6.87978 7.27066 7.32203V4.7872C6.36618 4.43124 5.47259 4.29102 4.5681 4.29102C2.35592 4.29102 0.884766 5.43439 0.884766 7.3436C0.884766 10.3207 5.02579 9.84607 5.02579 11.1297C5.02579 11.6258 4.58989 11.7876 3.97964 11.7876C3.07515 11.7876 1.92002 11.4209 1.00464 10.9247V13.4919C2.0181 13.9234 3.04246 14.1067 3.97964 14.1067C6.2463 14.1067 7.80464 12.9957 7.80464 11.0649C7.79374 7.85057 3.64182 8.42225 3.64182 7.21416Z",
    fill: "#635BFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61424_16471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeLogosvg);
export default __webpack_public_path__ + "static/media/stripeLogo.svg.25e3a9edc3fb594d2bd3e4f8f7893370.svg";
export { ForwardRef as ReactComponent };